export const MAKE_BOOKING_URL_SESSION_KEY = 'calsg.makebookingurl'
